// jshint esversion: 6
import './carousel/carousel.js';
import './ganalytics';
import activateChatbot from './chatbot';

require('./scss/index.scss');

function checkForChatbot() {
  // activate chatbot on certain pages
  const chatbotPages = [
    '#swimandgoseek-locations04',
    '#inoneearandouttheother-characters00',
    '#mythos-characters03',
    '#diaryofanant-characters07',
    '#thesuperlatives-locations00',
    '#wheels-locations01',
    '#behindtheclosetdoor-characters02',
  ]

  for (let page of chatbotPages) {
    if (location.hash == page &&
      document.querySelector('.ui-chatbox-log') === null) {
      window.setTimeout(function () {
        activateChatbot();
      }, 2200);
    }
  }
}

$(document).ready(function () {
  console.log('semaphore-studios.com v' + VERSION);
  console.log(
    '  - Art & design by Matt Evans <matt@grafikmythos.com>\n'
    + '  - Site mechanics by Andrew Bates <andrew@sprock.io>');

  checkForChatbot();

  $('body').attr('data-hash', location.hash.slice(1));

  $(window).on('hashchange', function () {
      // update body data-hash
      $('body').attr('data-hash', location.hash.slice(1));
      checkForChatbot();
    });

  (() => {

    // footer nav clicks
    $('.o-nav-footer a').on('click', function(event) {
      location.hash = location.hash.split('-')[0] +
        '-' + $(this).attr('data-category')+ '00';
      event.preventDefault();
    });

    $('.o-container').removeClass('hidden');

  })();
});




// WEBPACK FOOTER //
// ./webpack/entry.js